import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BankDetails, IResponse, IResponsePaginate, BankDetailsDto } from '@/types';

interface BankDetailsQuery {
  search?: string;
  nom?: string;
  agence?: string;
  rib?: string;
  deleted?: boolean;
  page?: number;
  size?: number;
  sort?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BankDetailsService {
  BASEURL = `${environment.api.paramsUrl}/compte_bancaire`;

  httpClient = inject(HttpClient);

  getBankDetails(params?: BankDetailsQuery): Observable<IResponsePaginate<BankDetails>> {
    return this.httpClient.get<IResponsePaginate<BankDetails>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getOneBankDetails(id: number): Observable<IResponse<BankDetails>> {
    return this.httpClient.get<IResponse<BankDetails>>(`${this.BASEURL}/${id}`);
  }

  addBankDetails(bankDetails: BankDetailsDto): Observable<IResponse<BankDetails>> {
    return this.httpClient.post<IResponse<BankDetails>>(`${this.BASEURL}`, bankDetails);
  }

  updateBankDetails(id: number, bankDetails: BankDetailsDto): Observable<IResponse<BankDetails>> {
    return this.httpClient.put<IResponse<BankDetails>>(`${this.BASEURL}/${id}`, bankDetails);
  }

  deleteBankDetails(id: number): Observable<IResponse<BankDetails>> {
    return this.httpClient.delete<IResponse<BankDetails>>(`${this.BASEURL}/${id}`);
  }
}
